import React from 'react';
import EntityPage from 'components/EntityPage';
import {
  fetchEntities,
  createEntity,
  updateEntity,
  archiveEntity,
  entitiesCleanUp,
} from 'state/actions/users';
import paths from 'pages/Router/paths';

import UserProfile from './UserProfile';
import UserForm from './UserForm';
import userSchema from './schema';

export default () => {
  const entityInfos = {
    i18nEntityName: 'User',
    entitiesName: 'users',
    entityName: 'user',
    contactEntitiesName: 'users',
    PATH_ENTITIES: paths.USERS,
  };
  const entityActions = {
    fetchEntities,
    createEntity,
    updateEntity,
    archiveEntity,
    entitiesCleanUp,
  };
  const { yupSchema } = userSchema;
  return (
    <EntityPage
      yupSchema={yupSchema}
      entityInfos={entityInfos}
      entityActions={entityActions}
      Profile={UserProfile}
      Form={UserForm}
    />
  );
};
